export const createSpan = (guid, marks, text) => {
    return {
        _type: 'span',
        _key: guid,
        marks: marks || [],
        text: text || ''
    };
};
export const createBlock = (guid, markDefs, style, children) => {
    return {
        _type: 'block',
        _key: guid,
        markDefs: markDefs || [],
        style: style || 'normal',
        children: children || []
    };
};
export const createListBlock = (guid, level, listItem, markDefs, style, children) => {
    return {
        _type: 'block',
        _key: guid,
        markDefs: markDefs || [],
        level: level,
        listItem: listItem,
        style: style || 'normal',
        children: children || []
    };
};
export const createImageBlock = (guid) => {
    return {
        _type: 'image',
        _key: guid,
        asset: {
            _type: 'reference',
            _ref: '',
            url: ''
        }
    };
};
export const createTableBlock = (guid, columns) => {
    return {
        _type: 'table',
        _key: guid,
        numColumns: columns,
        rows: []
    };
};
export const createItemLink = (guid, reference) => {
    return {
        _key: guid,
        _type: 'internalLink',
        reference: {
            _type: 'reference',
            _ref: reference
        }
    };
};
export const createTable = (guid, numColumns) => {
    return {
        _key: guid,
        _type: 'table',
        numColumns: numColumns,
        rows: []
    };
};
export const createTableRow = (guid) => {
    return {
        _key: guid,
        _type: 'row',
        cells: []
    };
};
export const createTableCell = (guid, childCount) => {
    return {
        _key: guid,
        _type: 'cell',
        content: [],
        childBlocksCount: childCount
    };
};
export const createExternalLink = (guid, attributes) => {
    return {
        _key: guid,
        _type: 'link',
        ...attributes
    };
};
export const createMark = (guid, value, type, childCount) => {
    return {
        _type: type,
        _key: guid,
        value: value,
        childCount: childCount
    };
};
export const createComponentBlock = (guid, reference) => {
    return {
        _type: 'component',
        _key: guid,
        component: reference
    };
};
export const isBlock = (block) => block._type === 'block';
export const isSpan = (span) => span._type === 'span';
export const compose = (firstFunction, ...functions) => functions.reduce((previousFunction, nextFunction) => value => previousFunction(nextFunction(value)), firstFunction);
export const findLastIndex = (arr, predicate) => {
    for (let i = arr.length - 1; i >= 0; i--) {
        if (predicate(arr[i])) {
            return i;
        }
    }
    return -1;
};
export const resolveTable = (table, resolver) => {
    let tableHtml = '<table><tbody>';
    const resolveCell = (cell) => {
        tableHtml += '<td>';
        for (let j = 0; j < cell.childBlocksCount; j++) {
            tableHtml += resolver(cell.content);
        }
        tableHtml += '</td>';
    };
    for (let i = 0; i < table.numColumns; i++) {
        const currentRow = table.rows[i];
        tableHtml += '<tr>';
        currentRow.cells.forEach(resolveCell);
        tableHtml += '</tr>';
    }
    tableHtml += '</tbody></table>';
    return tableHtml;
};
export const getAllNewLineAndWhiteSpace = /\n\s*/g;
